<mat-form-field *ngIf="years?.length" appearance="fill">
  <mat-label *ngIf="label !== ''">{{ label }}</mat-label>

  <mat-select
    [value]="selectedYear"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option *ngFor="let year of years" [value]="year">
      {{ year }}
    </mat-option>
  </mat-select>
</mat-form-field>
